export const degreeListConvertion = listOfDegree => {
  return (
    listOfDegree?.length &&
    listOfDegree?.map(item => {
      return {
        title: item?.name,
        value: item?.id,
        children: item?.stream?.map(data => {
          return {
            title: data?.name,
            value: data?.degreeStreamMapId,
            // Add specializations as children of departments (streams)
            children: data?.specialisation?.map(specMap => {
              const spec = specMap?.specialisation
              // Only include active specializations
              if (spec && spec.id && spec.name && spec.status === 1) {
                return {
                  title: spec?.name,
                  value: spec?.id,
                  isSpecialization: true, // Flag to identify specialization nodes
                }
              }
              return null
            })?.filter(Boolean) || [], // Remove null entries
          }
        }),
      }
    })
  )
}
